import { Writable, writable } from "svelte/store";
import type { Assessment } from "../services/assesment";
import { location, push } from "svelte-spa-router";

const NULL_DATE: number = -62135575764000;

export class UserState {
    cloc: string;
    constructor(
        public email: string = null,
        public userDetailsConfirmed: boolean = false,
        public isLoggedIn: boolean = false,
        public assessment: Assessment = null,
        public accessMode: string = null,
        public isHipaaSigned:boolean = false,
        public hipaaSignatureDate: Date=null) {
        location.subscribe(s => this.cloc = s);
    }

    get isBasicMode() : boolean{
        return this.accessMode==='basic';
    }

    get fullName(): string {
        if (this.assessment) {
            let result = this.assessment.firstName;
            if (this.assessment.middleName !== '') {
                result += ' ' + this.assessment.middleName;
            }
            result += ' ' + this.assessment.lastName;

            return result;
        }
        return '';
    }
}

export const userState: Writable<UserState> = writable(new UserState());

